
import axios from 'axios';
import store from '@/store';
import router from '@/router';

axios.defaults.baseURL = "/hezou";

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}

axios.interceptors.request.use((config) => {
  const serverToken = getCookie('server-token');
  const userId = getCookie('userId');
  if (serverToken) {
    config.headers.token = serverToken;
  }
  if (userId) {
    config.headers.userId = userId;
  }
  return config;
}, (error) => {
	return Promise.reject(error);
});

axios.interceptors.response.use(
	response => {
		if (response.status === 200) {
      const res = response.data;
      // 判断登录过期或未登录
      if (res.code === '401' || res.code === 401 || 
          res.code === '010015' || res.code === '010016') {
        store.commit('logout');
        router.push({ name: 'Login', query: { redirect: router.currentRoute.path } });
        return Promise.reject(new Error('登录已过期，请重新登录'));
      }
			return Promise.resolve(response.data);
		} else {
			return Promise.reject(response.data);
		}
	},
	(error) => {
    if (error.response && error.response.status === 401) {
      store.commit('logout');
      router.push({ name: 'Login', query: { redirect: router.currentRoute.path } });
    }
		console.log('error', error);
    return Promise.reject(error);
	}
);

export default axios;